var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckedIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 9C3 5.68629 5.68629 3 9 3H15C18.3137 3 21 5.68629 21 9V15C21 18.3137 18.3137 21 15 21H9C5.68629 21 3 18.3137 3 15V9Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 3C5.68629 3 3 5.68629 3 9L3 15C3 18.3137 5.68629 21 9 21H15C18.3137 21 21 18.3137 21 15V9C21 5.68629 18.3137 3 15 3L9 3ZM16.6364 9.88835C16.9879 9.53688 16.9879 8.96703 16.6364 8.61556C16.2849 8.26409 15.7151 8.26409 15.3636 8.61556L10.5043 13.4748L8.63638 11.6069C8.2849 11.2555 7.71505 11.2555 7.36359 11.607C7.01213 11.9585 7.01214 12.5283 7.36362 12.8798L9.86798 15.384C10.2195 15.7355 10.7893 15.7354 11.1408 15.384L16.6364 9.88835Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckedIcon);
export { ForwardRef as ReactComponent };